// extracted by mini-css-extract-plugin
module.exports = {"mCard":"Rf","image":"Sf","imageNoBackground":"Tf"};